<template>
  <div>
    <p class="titleModal">
      {{ $t('forms.labels.role') }}
    </p>

    <VSelect
      v-model="selectedRole"
      outlined
      :label="$t('forms.labels.role')"
      itemValue="key"
      :required="true"
      :items="displayedRoles"
      data-cy="role"
    />
    <p class="titleModal">
      {{ $t('forms.labels.members') }}
    </p>
    <VAutocomplete
      v-model="selectedMember"
      outlined
      :label="$t('forms.labels.members')"
      :items="displayedMembers"
      :loading="loading"
      :rules="{ required: true }"
      data-cy="members"
    />
  </div>
</template>

<script>
import roles from '@/utilities/enums/rolesTypes';
import VAutocomplete from '@/components/shared/widgets/forms/VuetifyInputs/VAutocomplete.vue';
import VSelect from '@/components/shared/widgets/forms/VuetifyInputs/VSelect.vue';

export default {
    components: {
        VAutocomplete,
        VSelect,
    },
    props: {
        associatedMembers: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            selectedRole: null,
            selectedMember: null,
            members: [],
            loading: false,
        };
    },
    computed: {
        displayedRoles() {
            const adminsAndManagers = [
                roles.ADMINISTRATOR,
                roles.LABMANAGER,
                roles.MANAGER,
                roles.LABMICROBIOLOGIST,
                roles.FINANCIALADMINISTRATOR,
            ];

            return Object.values(roles)
                .filter(role => !adminsAndManagers.includes(role) && role !== roles.OPERATOR)
                .map(role => ({
                    name: this.$t(`roles.${role}`),
                    key: role,
                }));
        },
        displayedMembers() {
            return this.members.map(member => ({
                name: `${member.firstName} ${member.lastName} (${member.email})`,
                id: member.id,
                disabled: this.isMemberAssociated(member.id),
            }));
        },
        associatedMembersById() {
            return this.associatedMembers.reduce((associatedMembersById, associatedMember) => ({
                ...associatedMembersById,
                [associatedMember.id]: associatedMember.id,
            }), {});
        },
        isMemberAssociated() {
            return memberId => memberId in this.associatedMembersById;
        },
    },
    watch: {
        selectedRole() {
            this.loading = true;
            this.getTeamMembers().then(members => {
                this.members = members;
                this.loading = false;
            });
        },
        selectedMember() {
            this.$emit('sendData', this.selectedMember);
        },
    },
    methods: {
        getTeamMembers() {
            return this.$rq.getTeamMembers(this.$store.getters.teamID, this.selectedRole, { allTeamMembers: true })
                .then(response => response.data.members);
        },
    },
};
</script>
